import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { ItemList, Slider, ICONS } from '../../../components'
import { TokenService } from '../../../services'
import { setCategory } from '../../../state/token'
import { Token } from './Token'
import { useSelector } from 'react-redux'
import NoTokenLocationSelected from '../NoTokenLocationSelected'
import SetCategoryForm from './SetCategoryForm'
import { useDispatch } from 'react-redux'

export const TokenList = (props) => {
  const dispatch = useDispatch()
  const { organization, tokenCategory } = useSelector(
    (state) => state.machineConfig
  )
  const [tokens, setTokens] = useState([])

  const getTokens = (category) => {
    TokenService.call_url_action(
      `tokens/new_tokens/${organization.code}/`,
      'GET'
    ).then((response) => {
      const temps = response.sort(function (a, b) {
        return a.token_number - b.token_number
      })
      if (category) {
        setTokens(temps.filter((x) => x.category === category))
      } else {
        setTokens(temps)
      }
    })
  }

  const renderToken = (index, key) => {
    return (
      <div key={tokens[index].url}>
        <Token token={tokens[index]}  onClose={getTokens}/>
      </div>
    )
  }

  return (
    <Slider
      onAfterOpen={() => organization && getTokens(tokenCategory)}
      title="Visitors"
      variant="link"
      className="text-dark"
      sliderWidth="50vw"
      header={
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="9">
            {organization ? (
              <>
                <strong>Customers awaiting at </strong>
                <br />
                <small className="text-danger">
                  {organization.name} <strong>({organization.code})</strong>
                </small>
              </>
            ) : (
              <strong>No visitors data available.</strong>
            )}
          </ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs="3">
            <Slider
              title={ICONS.SETTINGS}
              sliderWidth="50vw"
              style={{ position: 'fixed', right: 10 }}
              header="Bifurcate Tokens"
            >
              <SetCategoryForm
                onSubmit={(values) => {
                  if (values.category === 'ALL') {
                    dispatch(setCategory(null))
                    getTokens()
                  } else {
                    dispatch(setCategory(values.category))
                    getTokens(values.category)
                  }
                }}
              />
            </Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      }
    >
      {!organization && <NoTokenLocationSelected />}
      <>
        {organization && tokens && tokens.length === 0 ? (
          <>
            <ReactBootstrap.Alert variant="success">
              No Customer in waiting
            </ReactBootstrap.Alert>
          </>
        ) : (
          <>
            <ItemList
              variant="flush"
              itemRenderer={renderToken}
              length={tokens.length}
            />
          </>
        )}
      </>
    </Slider>
  )
}
